import Api from "../services/Api";
import { glasbeniSos } from "./glasbeniSos";
import 'svelte/store';
import { stationStore } from "../store";
const { allStations, stationName } = stationStore;
// sort from relative winner
export const getData = async (radioStation) => {
    const random = Math.floor(Math.random() * 99999 + 1);
    const response = await Api.get(`/preslikave/aktualno?client_id=82013fb3a531d5414f478747c1aca622&key=radio_onair_widget_v2`, {});
    if (response.response) {
        allStations.set(response.response);
        stationName.set(radioStation);
        if (radioStation === 'ra1') {
            radioStation = 'prvi';
        }
        glasbeniSos(radioStation);
    }
    /* try {
         const $ = get(dataContent);
         const random = Math.floor(Math.random() * 99999 + 1);
         const response = await Api.get(`preslikave/volitve2022?client_id=d268b6cb57822d7ef6c23e4f383089a4&_=${random}`, {});
         if (response.response.rezultati.slovenija) {
           const featuresArticles: HTMLElement  = document.querySelector(".featured-articles")!;
           if (featuresArticles){
             featuresArticles.parentElement.style.display = 'none';
           }
          
 
             if(response.response.rezultati.prestetih){
               counted.set(response.response.rezultati.prestetih + ' %')
             }
             response.response.rezultati.slovenija = response.response.rezultati.slovenija.sort(compare);
                 response.response.rezultati.slovenija.map(function (element) {
                     if (element.prc) {
                       element.prc = parseFloat((element.prc * 100).toFixed(2));
                       element.prcwriten = element.prc.toString(10).replace('.', ',');
                     }
                   });
                   dataContent.set(response.response.rezultati.slovenija);
                   showDate.set(response.response.rezultati.showDatum)
                   if (response.response.udelezba.slovenija.prc) {
                     response.response.udelezba.slovenija.prc = parseFloat((response.response.udelezba.slovenija.prc* 100).toFixed(2));
                     attandance.set(response.response.udelezba.slovenija.prc +'%')
                     
                   } else {
                     attandance.set('Podatek o udeležbi še ni na voljo')
                   }
                   
         }
       
     } catch (error) {
         console.log('error', error)
         
     }*/
};
